var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"body-2 schedule-frequency"},[_vm._v(_vm._s(_vm.frequency))]),(_vm.nextRun)?_c('div',{staticClass:"caption grey--text next-run"},[_vm._v("Next scheduled run: "+_vm._s(_vm.nextRun))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }